import type {
  FlightFare,
  FlightFareLeg,
} from "@/features/flights/components/flight-fares/types";
import type { BrandedFareTrackingProperties } from "@/lib/rudderstack";

export function getFareAnalyticsPayload(
  fare: FlightFare,
  leg: FlightFareLeg,
  type: "departure" | "return",
): BrandedFareTrackingProperties {
  return {
    type,
    departure: leg.departure,
    arrival: leg.arrival,
    brand_name: leg.brandName,
    price_difference: fare.priceDifference,
    cancel_variant:
      leg.changeRefund.find((c) => c.category === "cancel")?.variant ?? null,
    change_variant:
      leg.changeRefund.find((c) => c.category === "change")?.variant ?? null,
    baggage: leg.baggage
      .map(
        (baggage) =>
          `${baggage.baggageType}:${baggage.pieces}${baggage.weightKg ? `:${baggage.weightKg}kg` : ""}`,
      )
      .join(","),
  };
}
